import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@jana-technology/platform-ui";
import { captureException } from "@sentry/react";

import { LoadingSpinner } from "components/loaders";

export const Logout = () => {
  const navigate = useNavigate();

  const { logout } = useAuth();

  // might have to persist path in sessionStorage to restore on login
  useEffect(() => {
    logout({
      logoutParams: {
        returnTo: globalThis.location.origin,
      },
    }).catch((error) =>
      captureException(error, {
        tags: {
          component: "Logout",
        },
      }),
    );
  }, [logout, navigate]);

  return <LoadingSpinner loading className="h-screen w-screen" />;
};

export default Logout;
